import styled from 'styled-components';
import { ThemeMode } from '../../../global-state/themeContext';
import { Icon, Typography } from '../../../stories/atoms';
import { RowFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { muiTheme, percentToHex } from '../../../theme';
import { StoreVisibilityType } from '../storeVisibility/StoreVisibility';

const getTextColor = (status: StoreVisibilityType | '', mode: ThemeMode) => {
  if (status === 'OPEN') {
    return mode === 'dark' ? muiTheme.color.successLight : muiTheme.color.validationGreen;
  } else if (status === 'CLOSED' || status === 'REJECTED' || status === 'TEMPCLOSED') {
    return mode === 'dark' ? muiTheme.color.error : muiTheme.color.red;
  } else if (status === '') {
    return mode === 'dark' ? muiTheme.color.secondaryDarkTextGray : muiTheme.color.secondaryTextGray;
  } else {
    return mode === 'dark' ? muiTheme.color.warningLight : muiTheme.color.warningDark;
  }
};

const getBackgroundColor = (status: StoreVisibilityType | '', mode: ThemeMode) => {
  if (status === 'OPEN') {
    return mode === 'dark'
      ? percentToHex(muiTheme.color.validationGreen, 16)
      : muiTheme.color.successLightTransparent;
  } else if (status === 'CLOSED' || status === 'REJECTED' || status === 'TEMPCLOSED') {
    return percentToHex(muiTheme.color.error, 16);
  } else if (status === '') {
    return mode === 'dark' ? muiTheme.color.backgroundSelectedHover : muiTheme.color.backgroundSelectedHover;
  } else {
    return mode === 'dark' ? percentToHex(muiTheme.color.warningDark, 16) : muiTheme.color.backgroundWarning;
  }
};

export const StyledTypography = styled(Typography)<{ status: StoreVisibilityType | '' }>`
  color: ${({ theme: { palette }, status }) => getTextColor(status, palette.mode)};
`;

export const StyledIcon = styled(Icon)<{ status: StoreVisibilityType | '' }>`
  color: ${({ theme: { palette }, status }) => getTextColor(status, palette.mode)};
  width: ${({ theme: { spacing } }) => spacing(3)};
  height: ${({ theme: { spacing } }) => spacing(3)};
`;

export const StyledContainer = styled(RowFlexContainer)<{ status: StoreVisibilityType | '' }>`
  background-color: ${({ theme: { palette }, status }) => getBackgroundColor(status, palette.mode)};
`;
